import gql from 'graphql-tag';

export const OutgoingLinksQuery = gql`
	query OutgoingLinksQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				id
				outgoingLinks {
					externalOutgoingLinks {
						nodes {
							url
						}
					}
					internalOutgoingLinks {
						nodes {
							links {
								base
								webui
							}
						}
					}
				}
			}
		}
	}
`;
